/* ============================================================
   TRULAP — Product Rich Page JS
   custom.js
   ============================================================ */

(function () {
  'use strict';

  /* ── helpers ─────────────────────────────────────────── */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return [...(ctx || document).querySelectorAll(sel)]; }

  /* ══════════════════════════════════════════════════════
     INIT ALL PRP SECTIONS
     ══════════════════════════════════════════════════════ */
  function initPRP(section) {

    /* ── parse product JSON ───────────────────────────── */
    const jsonEl = qs('[data-prp-product-json]', section);
    if (!jsonEl) return;
    let data;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    const { product, variants } = data;

    /* ── DOM refs ─────────────────────────────────────── */
    const slides      = qsa('.prp__slide', section);
    const thumbs      = qsa('.prp__thumb', section);
    const variantIdInput = qs('[data-prp-variant-id]', section);
    const priceEl     = qs('[data-prp-price]', section);
    const compareEl   = qs('[data-prp-compare-price]', section);
    const atcBtn      = qs('[data-prp-atc]', section);
    const atcText     = qs('[data-prp-atc-text]', section);
    const qtyInput    = qs('[data-qty-input]', section);

    /* ── current selections state ─────────────────────── */
    // Derive initial selected options from the first/selected variant title
    const firstVariant  = variants[0];
    let selectedOptions = firstVariant ? [...firstVariant.options] : [];

    /* ── THUMBNAIL ────────────────────────────────────── */
    function goToSlide(index) {
      slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === index));
    }

    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => goToSlide(i));
    });

    /* ── find variant by options ──────────────────────── */
    function findVariant(opts) {
      return variants.find(v =>
        v.options.every((o, i) => o === opts[i])
      ) || null;
    }

    /* ── update UI to a variant ───────────────────────── */
    function updateToVariant(variant) {
      if (!variant) return;

      /* price */
      const price    = (variant.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
      const compare  = variant.compare_at_price
        ? (variant.compare_at_price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' })
        : null;

      if (priceEl)   priceEl.textContent   = price;
      if (compareEl) {
        compareEl.textContent = compare || '';
        compareEl.classList.toggle('is-hidden', !compare || variant.compare_at_price <= variant.price);
      }

      /* ATC button */
      if (atcBtn)  atcBtn.disabled = !variant.available;
      if (atcText) atcText.textContent = variant.available ? 'Add to cart' : 'Sold out';

      /* hidden variant id */
      if (variantIdInput) variantIdInput.value = variant.id;

      /* jump to variant media if available */
      if (variant.featured_media) {
        goToSlide(variant.featured_media.position - 1);
      }

      /* update url */
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    /* ── SWATCH clicks ────────────────────────────────── */
    qsa('.prp__swatch', section).forEach(btn => {
      btn.addEventListener('click', () => {
        const name  = btn.dataset.optionName;
        const value = btn.dataset.optionValue;

        /* find option index for this option name */
        const optIdx = product.options.indexOf(name);
        if (optIdx === -1) return;

        /* deactivate siblings, activate this */
        qsa(`.prp__swatch[data-option-name="${name}"]`, section).forEach(s => s.classList.remove('is-active'));
        btn.classList.add('is-active');

        selectedOptions[optIdx] = value;
        const variant = findVariant(selectedOptions);
        if (variant) updateToVariant(variant);
      });
    });

    /* ── SELECT changes ───────────────────────────────── */
    qsa('[data-option-select]', section).forEach(sel => {
      sel.addEventListener('change', () => {
        const name  = sel.dataset.optionName;
        const value = sel.value;
        const optIdx = product.options.indexOf(name);
        if (optIdx === -1) return;
        selectedOptions[optIdx] = value;
        const variant = findVariant(selectedOptions);
        if (variant) updateToVariant(variant);
      });
    });

    /* ── QUANTITY ─────────────────────────────────────── */
    function changeQty(delta) {
      if (!qtyInput) return;
      const current = parseInt(qtyInput.value, 10) || 1;
      const next    = Math.max(1, current + delta);
      qtyInput.value = next;
    }

    const minusBtn = qs('[data-qty-minus]', section);
    const plusBtn  = qs('[data-qty-plus]', section);
    if (minusBtn) minusBtn.addEventListener('click', () => changeQty(-1));
    if (plusBtn)  plusBtn.addEventListener('click',  () => changeQty(+1));

    if (qtyInput) {
      qtyInput.addEventListener('change', () => {
        const v = parseInt(qtyInput.value, 10);
        if (isNaN(v) || v < 1) qtyInput.value = 1;
      });
    }

    /* ── ACCORDIONS ───────────────────────────────────── */
    qsa('[data-accordion-trigger]', section).forEach(trigger => {
      const content = trigger.nextElementSibling;
      trigger.addEventListener('click', () => {
        const isOpen = trigger.getAttribute('aria-expanded') === 'true';

        /* close all */
        qsa('[data-accordion-trigger]', section).forEach(t => {
          t.setAttribute('aria-expanded', 'false');
          if (t.nextElementSibling) t.nextElementSibling.style.maxHeight = '0';
        });

        /* open this one if it was closed */
        if (!isOpen) {
          trigger.setAttribute('aria-expanded', 'true');
          if (content) content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    });

  } /* end initPRP */

  /* ── run on all sections ───────────────────────────── */
  document.querySelectorAll('[data-product-id]').forEach(initPRP);

})();


(function () {
  function getSlidesPerView() {
    if (window.innerWidth < 768) return 1;
    if (window.innerWidth < 1024) return 2;
    return 3;
  }

  function getSpaceBetween() {
    if (window.innerWidth < 768) return 12;
    if (window.innerWidth < 1024) return 16;
    return 20;
  }

  function updateTrustooSwiper() {
    document.querySelectorAll('.tt-swiper-container').forEach(function (wrapper) {
      var swiperEl = wrapper.closest('.swiper') || wrapper.parentElement;

      if (swiperEl && swiperEl.swiper) {
        var slidesView = getSlidesPerView();
        var space = getSpaceBetween();

        swiperEl.swiper.params.slidesPerView = slidesView;
        swiperEl.swiper.params.spaceBetween = space;

        swiperEl.swiper.params.breakpoints = {
          0: {
            slidesPerView: 1,
            spaceBetween: 12
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 16
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 20
          }
        };

        swiperEl.swiper.update();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(updateTrustooSwiper, 500);
    setTimeout(updateTrustooSwiper, 1500);
    setTimeout(updateTrustooSwiper, 3000);
    setTimeout(updateTrustooSwiper, 5000);
  });

  window.addEventListener('load', function () {
    setTimeout(updateTrustooSwiper, 500);
    setTimeout(updateTrustooSwiper, 1500);
  });

  window.addEventListener('resize', function () {
    clearTimeout(window.trustooResizeTimer);
    window.trustooResizeTimer = setTimeout(updateTrustooSwiper, 250);
  });
})();



(function () {
  function fixTrustooMobileCarousel() {
    var carousel = document.querySelector('#tt-carousel-list');

    if (!carousel || !carousel.swiper) return;

    var swiper = carousel.swiper;

    if (window.innerWidth <= 767) {
      swiper.params.slidesPerView = 1;
      swiper.params.spaceBetween = 0;
      swiper.params.centeredSlides = false;
      swiper.params.slidesOffsetBefore = 0;
      swiper.params.slidesOffsetAfter = 0;

      if (swiper.params.breakpoints) {
        Object.keys(swiper.params.breakpoints).forEach(function (bp) {
          swiper.params.breakpoints[bp].slidesPerView = 1;
          swiper.params.breakpoints[bp].spaceBetween = 0;
          swiper.params.breakpoints[bp].centeredSlides = false;
          swiper.params.breakpoints[bp].slidesOffsetBefore = 0;
          swiper.params.breakpoints[bp].slidesOffsetAfter = 0;
        });
      }

      swiper.update();
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(fixTrustooMobileCarousel, 500);
    setTimeout(fixTrustooMobileCarousel, 1500);
    setTimeout(fixTrustooMobileCarousel, 3000);
  });

  window.addEventListener('load', function () {
    setTimeout(fixTrustooMobileCarousel, 500);
    setTimeout(fixTrustooMobileCarousel, 1500);
  });

  window.addEventListener('resize', function () {
    setTimeout(fixTrustooMobileCarousel, 300);
  });
})();